import React from 'react';

const SkeletonLoader = ({ 
  width = '100%', 
  height = '1rem', 
  className = '', 
  rounded = 'rounded',
  animate = true 
}) => {
  const animationClass = animate ? 'animate-pulse' : '';
  
  return (
    <div
      className={`bg-slate-700/50 ${rounded} ${animationClass} ${className}`}
      style={{ width, height }}
      aria-hidden="true"
    />
  );
};

export const BlogCardSkeleton = () => (
  <div className="spotlight-card">
    <div className="spotlight-content">
      <div className="space-y-4">
        {/* Title skeleton */}
        <SkeletonLoader height="1.5rem" width="85%" />
        
        {/* Meta info skeleton */}
        <div className="flex items-center gap-4">
          <SkeletonLoader height="0.875rem" width="6rem" />
          <SkeletonLoader height="0.875rem" width="4rem" />
        </div>
        
        {/* Content skeleton */}
        <div className="space-y-2">
          <SkeletonLoader height="1rem" width="100%" />
          <SkeletonLoader height="1rem" width="95%" />
          <SkeletonLoader height="1rem" width="80%" />
        </div>
        
        {/* Tags skeleton */}
        <div className="flex gap-2 pt-2">
          <SkeletonLoader height="1.5rem" width="4rem" rounded="rounded-full" />
          <SkeletonLoader height="1.5rem" width="5rem" rounded="rounded-full" />
          <SkeletonLoader height="1.5rem" width="3rem" rounded="rounded-full" />
        </div>
      </div>
    </div>
  </div>
);

export const BlogPostSkeleton = () => (
  <div className="blog-post-container">
    <div className="blog-post-header">
      {/* Title skeleton */}
      <SkeletonLoader height="2.5rem" width="80%" className="mx-auto mb-4" />
      
      {/* Meta skeleton */}
      <div className="flex justify-center items-center gap-4 mb-6">
        <SkeletonLoader height="0.875rem" width="6rem" />
        <SkeletonLoader height="0.875rem" width="4rem" />
      </div>
      
      {/* Tags skeleton */}
      <div className="flex justify-center gap-2">
        <SkeletonLoader height="1.5rem" width="4rem" rounded="rounded-full" />
        <SkeletonLoader height="1.5rem" width="5rem" rounded="rounded-full" />
      </div>
    </div>
    
    {/* Content skeleton */}
    <div className="space-y-4">
      {Array.from({ length: 8 }).map((_, i) => (
        <SkeletonLoader 
          key={i}
          height="1rem" 
          width={i % 3 === 0 ? '90%' : i % 2 === 0 ? '95%' : '100%'} 
        />
      ))}
      
      {/* Code block skeleton */}
      <div className="my-6 p-4 bg-slate-800/50 rounded-lg">
        {Array.from({ length: 4 }).map((_, i) => (
          <SkeletonLoader 
            key={i}
            height="1rem" 
            width={i === 3 ? '60%' : '85%'} 
            className="mb-2"
          />
        ))}
      </div>
      
      {Array.from({ length: 6 }).map((_, i) => (
        <SkeletonLoader 
          key={i + 8}
          height="1rem" 
          width={i % 3 === 0 ? '85%' : i % 2 === 0 ? '100%' : '92%'} 
        />
      ))}
    </div>
  </div>
);

export const BlogListSkeleton = () => (
  <div className="blog-content">
    {/* Actual Header - no skeleton needed for static content */}
    <header className="blog-header">
      <h1 className="blog-title">oooooOOOOOOOO Javorski</h1>
      <p className="blog-subtitle">
        Security researcher with focus on game anti-cheat technologies and operating system internals.
      </p>
    </header>
    
    {/* Controls skeleton */}
    <div className="blog-controls mb-6">
      <div className="blog-controls-row">
        <div className="search-input form-group">
          <SkeletonLoader height="3rem" width="100%" rounded="rounded-lg" />
        </div>
        <div className="filter-select form-group">
          <SkeletonLoader height="3rem" width="100%" rounded="rounded-lg" />
        </div>
      </div>
    </div>
    
    {/* Blog cards skeleton */}
    <div className="blog-grid">
      {Array.from({ length: 3 }).map((_, i) => (
        <BlogCardSkeleton key={i} />
      ))}
    </div>
  </div>
);

export default SkeletonLoader;